import { Injectable, inject } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { ContainerService } from '@app/core/services/container.service';

/**
 * Attaches CDK Overlay's `.cdk-overlay-container` element to `#bs5-container`
 * inside the app's shadow-DOM context instead of `document.body`.
 *
 * Why: the Angular app is wrapped in `<fdx-style-wrapper>` which uses
 * `ViewEncapsulation.ShadowDom`. Overlays that render in `document.body` end
 * up outside the shadow root and lose access to the Bootstrap 5 / Feedonomics
 * styles that are scoped inside it. `#bs5-container` is the project's
 * established teleport target inside the shadow root and is also used by
 * `ModalService` for the same reason.
 */
@Injectable({ providedIn: 'root' })
export class ShadowRootOverlayContainer extends OverlayContainer {
    private readonly containerService: ContainerService = inject(ContainerService);

    // eslint-disable-next-line @typescript-eslint/naming-convention
    protected override _createContainer(): void {
        const host: HTMLElement = this.containerService.getContainer('ShadowRootOverlayContainer');
        const container: HTMLDivElement = this._document.createElement('div');
        container.classList.add('cdk-overlay-container');
        host.appendChild(container);
        this._containerElement = container;
    }
}
